import { useQuery } from "@tanstack/react-query";
import { rpc } from "@vixio/data";
import type { PublicContacts } from "./rpc-types";

/**
 * Contatos configuráveis da organização (Configurações → Gerais: org.contact_email e org.privacy_email).
 * Sem organização (telas de login), os da organização principal. Funciona sem sessão (anon).
 */
export function usePublicContacts(orgId?: string | null) {
  return useQuery({
    queryKey: ["core", "public_contacts", orgId ?? "principal"],
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<PublicContacts> => {
      try {
        return await rpc("core", "public_contacts", { p_org: orgId ?? null });
      } catch {
        return { organization: null, contact_email: null, privacy_email: null };
      }
    },
  });
}
